/**
 * Enum que define los tipos de modal utilizados en la página de Desconexiones.
 */
export enum ModalTipoDesconexionesEnum {
  AGREGAR_INDIVIDUAL = 'AgregarIndividual',
  AGREGAR_MASIVO = 'AgregarMasivo',
  EDITAR = 'Editar',
  ELIMINAR = 'Eliminar',
  CONFIRMAR_SALIDA_EDITAR = 'SalirEditar',
}
